import { render, staticRenderFns } from "./TreeViewFolder.vue?vue&type=template&id=8d4f3b18&scoped=true"
import script from "./TreeViewFolder.vue?vue&type=script&lang=js"
export * from "./TreeViewFolder.vue?vue&type=script&lang=js"
import style0 from "./TreeViewFolder.vue?vue&type=style&index=0&id=8d4f3b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4f3b18",
  null
  
)

export default component.exports